import { render, staticRenderFns } from "./ViewEmployeesHead.vue?vue&type=template&id=07861b0c&scoped=true"
import script from "./ViewEmployeesHead.vue?vue&type=script&lang=ts"
export * from "./ViewEmployeesHead.vue?vue&type=script&lang=ts"
import style0 from "./ViewEmployeesHead.vue?vue&type=style&index=0&id=07861b0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07861b0c",
  null
  
)

export default component.exports